<template>
  <div class="text-center pt-5">
    <h1>
      404
    </h1>
    <h2>
      {{ $t("Página no encontrada") }}
    </h2>
  </div>
</template>

<script>
export default {
    name: "P404"
};
</script>

<style scoped>

</style>
